import { getApiUrl } from '@/config/api'

/** URL builders for the ENG-3630/ENG-3631 learner preference contract. */
export const notificationPreferencesService = {
  getOwnPreferencesUrl: () => getApiUrl('/users/me/communication-preferences'),
}
